module.exports = __webpack_public_path__ + "img/135.fcfe2d5e.jpg";